import Schema from "form-schema-validation";
import {maxLengthValidator} from "../validators";
import {ErrorMessages} from "./ErrorMessages";
import i18n from "i18next";

const emailValidator = () => ({
    validator: (value, field, model) => {
        if (model.isNotification) {
            if (value.trim() === '') {
                return [i18n.t("common:validation.notBlank")];
            }
            // eslint-disable-next-line
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (value && !re.test(String(value).toLowerCase())) {
                return [i18n.t("common:validation.email")];
            }
        }
    }
});

const notBlank = () => ({
    validator: (value, field, model) => {
        if (model.isNotification) {
            if (value.trim() === '') {
                return [i18n.t("common:validation.notBlank")];
            }
        }
    }
});

const phoneValidator = () => ({
    validator: (value) => {
        if (value && !value.match(/^(\(?\+\d{1,3}\)?)?\s?[\d\s]+$/)) {
            return [i18n.t("common:validation.number")];
        }
    }
});


export const problemObjectSchema = new Schema({
    cityObjectId: {
        type: Number,
        required: false,
        defaultValue: 0
    },
    type: {
        type: String,
        required: true,
        defaultValue: ""
    },
    typeGroup: {
        type: String,
        required: true,
        defaultValue: ""
    },
    description: {
        type: String,
        required: true,
        validators: [maxLengthValidator(500)],
        defaultValue: ''
    },
    pointX: {
        type: Number,
        defaultValue: 0,
        required: true
    },
    pointY: {
        type: Number,
        defaultValue: 0,
        required: true
    },
    files: {
        type: Array,
        required: false
    },
    isNotification: {
        type: Boolean,
        defaultValue: false,
    },
    responsiveDepartment: {
        type: String,
        required: false,
        defaultValue: ""
    },
    responsiveCompany: {
        type: String,
        required: false,
        defaultValue: ""
    },
    firstName: {
        type: String,
        validators: [maxLengthValidator(125), notBlank()]
    },
    lastName: {
        type: String,
        validators: [maxLengthValidator(125), notBlank()]
    },
    email: {
        type: String,
        validators: [maxLengthValidator(125), emailValidator()]
    },
    phone: {
        type: String,
        validators: [maxLengthValidator(125), phoneValidator()]
    },
    objectOwner: {
        type: String,
        required: false,
        defaultValue: ""
    }
}, ErrorMessages);
